import { useProfile } from "@/hooks/useProfile";
import { useMonitorGym } from "@/hooks/monitor/useMonitorGym";
import { GymSelector } from "@/components/monitor/GymSelector";
import { ValidationView } from "@/components/monitor/ValidationView";
import { Loader2 } from "lucide-react";

const Monitor = () => {
  const { profile, isLoading: profileLoading } = useProfile();
  const { gym, isLoading: gymLoading, assignGym } = useMonitorGym(
    profile?.id || null,
    profile?.gym_id || null
  );

  // Show loading while fetching profile or gym
  if (profileLoading || gymLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // If no gym assigned, show selector
  if (!gym) {
    return <GymSelector onSelect={assignGym} />;
  }

  // Show validation view
  return <ValidationView gym={gym} />;
};

export default Monitor;
